import { useState, useEffect } from 'react'
import { Auth } from 'aws-amplify'
import axios from 'axios'
import CustomerList from './CustomerList'

const Customers = () => {
    const [customerData, setCustomerData] = useState([])
    const [errorMsg, setErrorMsg] = useState('')
    const [loading, setLoading] = useState(false)
    const [saving, setSaving] = useState(false)
    const [adding, setAdding] = useState(false)
    const [newCustomerName, setNewCustomerName] = useState(null)
    const [newCustomerType, setNewCustomerType] = useState(null)

    useEffect (() => {
      getCustomers()
    }, [])

    const getCustomers = async () => {

        setErrorMsg('')
        setLoading(true)
        setCustomerData([])
        let session = await Auth.currentSession()
        let jwt = session.getIdToken().getJwtToken()

        axios
        .get(`${process.env.REACT_APP_API_URL}/customer`,
        {headers: {Authorization: jwt}}
        )
        .then(response => {
            setCustomerData(response.data.rows)
            setLoading(false)
            })
        .catch(error => {
            console.log('The error is: ', error)
            setErrorMsg('Problem retrieving data: ', error)
            setLoading(false)
        })            
    }

    const addNewClick = () => {
      setAdding(true)
      setNewCustomerType(1)
    }

    const onCancelClick = () => {
      setNewCustomerName(null)
      setAdding(false)
    }

    const saveCustomer = async (e) => {
      e.preventDefault()

      setErrorMsg('')
      setSaving(true)
      let session = await Auth.currentSession()
      let jwt = session.getIdToken().getJwtToken()
      axios
          .put(`${process.env.REACT_APP_API_URL}/customer`, {updateType: 'insert', customerName: newCustomerName, customerType: newCustomerType},
          {headers: {Authorization: jwt}}
          )
          .then(response => {
              setCustomerData(response.data.rows.map(newCustomerItem => {
                  return newCustomerItem
              }))
              setSaving(false)
              setNewCustomerName(null)
              setAdding(false)
          })
          .catch(error => {
              console.log('The error is: ', error)
              setErrorMsg('Problem saving data: ', error)
              setSaving(false)
          })            
    }

    return (
        <div className="report">
          <h2>Customers</h2>
          { loading && <h3>Loading...</h3>}
          {errorMsg && <p className="form__error">{errorMsg}</p>}
          {!adding && <button className="button" onClick={addNewClick} disabled={loading || adding}>Add New</button>}
          {adding && <div>
            <h4>New Customer:</h4>
            { saving && <h3>Saving...</h3>}
            <table className="styled-table">
              <thead>
                <tr>
                  <th>Customer Name</th>
                  <th>Customer Type</th>
                  <th></th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>
                    <input 
                    type="text"
                    min="0"
                    className="text-input__customer-add"
                    name="customerName"
                    value={newCustomerName}
                    disabled={saving}
                    onChange={e => setNewCustomerName(e.target.value) } />
                  </td>
                  <td>
                    <select className="msc__select text-input__margin" id="customerType" onChange={e => setNewCustomerType(e.target.value)}>
                      <option key='1' value='1'>External</option>
                      <option key='2' value='2'>Internal</option>
                    </select>
                  </td>                  
                  <td>
                    <button className="table-button" onClick={onCancelClick} disabled={saving}>Cancel</button>
                  </td>
                  <td>
                    <button className="table-button" onClick={saveCustomer} disabled={saving || !newCustomerName} >Add</button>
                  </td>
                </tr>
              </tbody>
            </table>              
          </div>}
          {customerData.length > 0 && <div >
            <h4>Current Customers:</h4>
            <table className="styled-table styled-table__fixed">
              <thead>
                  <tr>
                      <th>Customer Name</th>
                      <th>Customer Type</th>
                      <th></th>
                      <th></th>
                  </tr>
              </thead>
              <tbody>
                {customerData.map((customerItem) => (
                  <CustomerList
                    key={customerItem.customer_id}
                    customerItem={customerItem}
                    setCustomerData={setCustomerData}
                    setErrorMsg={setErrorMsg}
                  />
                ))}
              </tbody>
            </table>
          </div>}
        </div>
    )
}

export default Customers